export function getFooterStyles(theme: "light" | "dark"): string {
  const isDark = theme === "dark";

  return `
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      background: transparent;
    }

    :host([data-mount="inline-append"]),
    :host([data-mount="inline-sibling"]) {
      display: inline-flex;
      width: auto;
      max-width: none;
      vertical-align: middle;
    }

    .pf-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      background: transparent;
    }

    .pf-wrap--inline {
      padding: 12px 16px 0;
    }

    :host([data-platform="nuvemshop"]) .pf-wrap--inline {
      padding: 0 16px 20px;
    }

    :host([data-platform="shopify"]) .pf-wrap--inline {
      padding: 0 16px 20px;
    }

    .pf-wrap--fixed {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      padding: 8px 16px;
      background: ${isDark ? "rgba(15, 15, 15, 0.92)" : "rgba(255, 255, 255, 0.96)"};
      border-top: 1px solid ${isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)"};
      backdrop-filter: blur(8px);
    }

    .pf-link {
      color: ${isDark ? "#f5f5f5" : "#333333"};
      text-decoration: none;
      font-size: 11px;
      line-height: 1.4;
      letter-spacing: 0.01em;
      transition: opacity 0.2s ease;
    }

    .pf-link--composed {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }

    .pf-separator {
      margin: 0 0.65em;
      opacity: 0.55;
      user-select: none;
    }

    :host([data-mount="inline-append"]) .pf-wrap--inline,
    :host([data-mount="inline-sibling"]) .pf-wrap--inline {
      padding: 0;
      width: auto;
    }

    :host([data-mount="inline-append"]) .pf-wrap,
    :host([data-mount="inline-sibling"]) .pf-wrap {
      width: auto;
    }

    .pf-slot {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .pf-slot--brand {
      gap: 8px;
    }

    /* Somente labelAfter a direita */
    .pf-link--after-right:not(.pf-link--before-left):not(.pf-link--before-top) {
      flex-direction: row;
    }

    /* Esquerda + direita (linha) */
    .pf-link--before-left.pf-link--after-right,
    .pf-link--before-left:not(.pf-link--after-bottom):not(.pf-link--after-right) {
      flex-direction: row;
    }

    .pf-link--before-left:not(.pf-link--after-bottom):not(.pf-link--after-right) .pf-text--before {
      white-space: nowrap;
    }

    /* Acima + abaixo (coluna) */
    .pf-link--before-top.pf-link--after-bottom,
    .pf-link--before-top:not(.pf-link--after-right):not(.pf-link--after-bottom),
    .pf-link--after-bottom:not(.pf-link--before-left):not(.pf-link--before-top) {
      flex-direction: column;
    }

    .pf-link--before-top .pf-slot--before,
    .pf-link--after-bottom .pf-slot--after,
    .pf-link--before-top.pf-link--after-bottom .pf-text {
      text-align: center;
      width: 100%;
    }

    /* Esquerda + abaixo */
    .pf-link--before-left.pf-link--after-bottom {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: auto auto;
      justify-content: center;
      align-items: center;
      column-gap: 10px;
      row-gap: 8px;
    }

    .pf-link--before-left.pf-link--after-bottom .pf-slot--before {
      grid-column: 1;
      grid-row: 1;
      justify-self: end;
    }

    .pf-link--before-left.pf-link--after-bottom .pf-slot--brand {
      grid-column: 2;
      grid-row: 1;
    }

    .pf-link--before-left.pf-link--after-bottom .pf-slot--after {
      grid-column: 1 / -1;
      grid-row: 2;
      width: 100%;
      text-align: center;
    }

    /* Acima + direita */
    .pf-link--before-top.pf-link--after-right {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: auto auto;
      justify-content: center;
      align-items: center;
      column-gap: 10px;
      row-gap: 8px;
    }

    .pf-link--before-top.pf-link--after-right .pf-slot--before {
      grid-column: 1 / -1;
      grid-row: 1;
      width: 100%;
      text-align: center;
    }

    .pf-link--before-top.pf-link--after-right .pf-slot--brand {
      grid-column: 1;
      grid-row: 2;
      justify-self: end;
    }

    .pf-link--before-top.pf-link--after-right .pf-slot--after {
      grid-column: 2;
      grid-row: 2;
      align-self: center;
    }

    .pf-link:hover,
    .pf-link:focus-visible {
      opacity: 0.78;
      outline: none;
    }

    .pf-link:focus-visible {
      box-shadow: 0 0 0 2px ${isDark ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.25)"};
      border-radius: 4px;
    }

    .pf-logo {
      display: block;
      height: 24px;
      width: auto;
      max-width: 160px;
    }

    .pf-link--composed .pf-logo {
      height: 22px;
    }

    .pf-logo--icon {
      height: 28px;
      width: 28px;
      max-width: 28px;
      border-radius: 6px;
      object-fit: cover;
    }

    .pf-avatar {
      display: block;
      height: 28px;
      width: 28px;
      border-radius: 999px;
      object-fit: cover;
      flex-shrink: 0;
    }

    .pf-text {
      margin: 0;
      text-align: center;
      white-space: normal;
    }

    @media (max-width: 767px) {
      :host([data-mount="inline-append"]) .pf-wrap--inline,
      :host([data-mount="inline-sibling"]) .pf-wrap--inline {
        padding-top: 12px;
      }

      .pf-separator {
        display: none;
      }

      .pf-link--before-left:not(.pf-link--after-bottom):not(.pf-link--after-right) {
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 8px;
      }
    }
  `;
}

function parseColorString(color: string): { css: string; luminance: number } | null {
  const trimmed = color.trim();

  if (!trimmed || trimmed === "transparent" || trimmed === "none") {
    return null;
  }

  if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(trimmed)) {
    let hex = trimmed.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }
    const r = Number.parseInt(hex.slice(0, 2), 16);
    const g = Number.parseInt(hex.slice(2, 4), 16);
    const b = Number.parseInt(hex.slice(4, 6), 16);
    return colorValues(r, g, b);
  }

  const modern = trimmed.match(
    /^rgba?\(\s*(\d+)\s+(\d+)\s+(\d+)(?:\s*\/\s*([\d.]+))?\s*\)$/i
  );
  if (modern) {
    const alpha = modern[4] !== undefined ? Number(modern[4]) : 1;
    if (alpha <= 0.08) {
      return null;
    }
    return colorValues(Number(modern[1]), Number(modern[2]), Number(modern[3]));
  }

  const classic = trimmed.match(
    /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*\/\s*([\d.]+)|\s*,\s*([\d.]+))?\s*\)$/i
  );
  if (classic) {
    const alphaRaw = classic[4] ?? classic[5];
    const alpha = alphaRaw !== undefined ? Number(alphaRaw) : 1;
    if (alpha <= 0.08) {
      return null;
    }
    return colorValues(Number(classic[1]), Number(classic[2]), Number(classic[3]));
  }

  return null;
}

function colorValues(r: number, g: number, b: number): { css: string; luminance: number } {
  const css = `rgb(${r}, ${g}, ${b})`;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return { css, luminance };
}

export function normalizeBackgroundColor(value: string | undefined): string | null {
  if (!value?.trim()) {
    return null;
  }
  return parseColorString(value.trim())?.css ?? null;
}

const SCHEME_BACKGROUND_VARS = [
  "--color-background",
  "--color-background-rgb",
] as const;

function hasColorSchemeClass(element: HTMLElement): boolean {
  return [...element.classList].some((name) => name.startsWith("color-scheme"));
}

function readSchemeBackground(element: HTMLElement): string | null {
  const style = window.getComputedStyle(element);

  for (const varName of SCHEME_BACKGROUND_VARS) {
    const raw = style.getPropertyValue(varName).trim();
    if (!raw || raw.includes("gradient")) {
      continue;
    }

    const parsed = parseColorString(raw);
    if (parsed) {
      return parsed.css;
    }
  }

  return null;
}

/** Shopify Dawn: --color-background em .color-scheme-* (ex.: rgb(3 3 2 / 1)). */
export function resolveSchemeBackground(target: HTMLElement): string | null {
  const elements = collectFooterElements(target);
  const candidates: { css: string; area: number; prefersScheme: boolean }[] = [];

  for (const el of elements) {
    const css = readSchemeBackground(el);
    if (!css) {
      continue;
    }

    const area = el.offsetWidth * el.offsetHeight;
    if (area <= 0) {
      continue;
    }

    candidates.push({
      css,
      area,
      prefersScheme: hasColorSchemeClass(el),
    });
  }

  let node: HTMLElement | null = target;
  while (node) {
    const css = readSchemeBackground(node);
    if (css) {
      const area = node.offsetWidth * node.offsetHeight;
      candidates.push({
        css,
        area: area > 0 ? area : 1,
        prefersScheme: hasColorSchemeClass(node),
      });
    }
    node = node.parentElement;
  }

  if (candidates.length === 0) {
    return null;
  }

  candidates.sort((a, b) => {
    if (a.prefersScheme !== b.prefersScheme) {
      return a.prefersScheme ? -1 : 1;
    }
    return b.area - a.area;
  });

  return candidates[0].css;
}

function collectFooterElements(target: HTMLElement): HTMLElement[] {
  const footerRoot =
    target.closest("footer, .shopify-section-footer, #shopify-section-footer") ??
    target.closest('[class*="footer" i], [id*="footer" i]');

  const elements: HTMLElement[] = [];
  const seen = new Set<HTMLElement>();

  const add = (el: HTMLElement | null | undefined) => {
    if (!el || seen.has(el)) {
      return;
    }
    seen.add(el);
    elements.push(el);
  };

  if (footerRoot instanceof HTMLElement) {
    add(footerRoot);
    footerRoot.querySelectorAll("*").forEach((node) => {
      if (node instanceof HTMLElement) {
        add(node);
      }
    });
  }

  let node: HTMLElement | null = target;
  while (node) {
    add(node);
    if (node === footerRoot) {
      break;
    }
    node = node.parentElement;
  }

  return elements;
}

/** Cor de superficie do rodape — busca em filhos aninhados; prefere area visivel maior. */
export function resolveFooterSurfaceBackground(
  target: HTMLElement,
  theme: "light" | "dark"
): string | null {
  const elements = collectFooterElements(target);
  const opaque: { css: string; luminance: number; area: number }[] = [];

  for (const el of elements) {
    const parsed = parseColorString(window.getComputedStyle(el).backgroundColor);
    if (!parsed) {
      continue;
    }

    const area = el.offsetWidth * el.offsetHeight;
    if (area <= 0) {
      continue;
    }

    opaque.push({ ...parsed, area });
  }

  if (opaque.length === 0) {
    return null;
  }

  opaque.sort((a, b) => {
    const tone = theme === "dark" ? a.luminance - b.luminance : b.luminance - a.luminance;
    if (Math.abs(a.luminance - b.luminance) > 0.05) {
      return tone;
    }
    return b.area - a.area;
  });

  return opaque[0].css;
}

export function resolveTheme(
  requested: "light" | "dark" | "auto",
  container: ParentNode | null
): "light" | "dark" {
  if (requested === "light" || requested === "dark") {
    return requested;
  }

  const start =
    container instanceof HTMLElement
      ? container
      : document.querySelector("footer") ?? document.body;

  if (!(start instanceof HTMLElement)) {
    return "light";
  }

  let node: HTMLElement | null = start;
  while (node) {
    const background = window.getComputedStyle(node).backgroundColor;
    const match = background.match(
      /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/i
    );

    if (match) {
      const alpha = match[4] !== undefined ? Number(match[4]) : 1;
      if (alpha > 0.08) {
        const r = Number(match[1]);
        const g = Number(match[2]);
        const b = Number(match[3]);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance < 0.55 ? "dark" : "light";
      }
    }

    node = node.parentElement;
  }

  return "light";
}
